import { z } from 'zod';
export var FlowRunExportJobStatus;
(function (FlowRunExportJobStatus) {
    FlowRunExportJobStatus["Pending"] = "Pending";
    FlowRunExportJobStatus["Processing"] = "Processing";
    FlowRunExportJobStatus["Completed"] = "Completed";
    FlowRunExportJobStatus["Failed"] = "Failed";
    FlowRunExportJobStatus["Canceled"] = "Canceled";
})(FlowRunExportJobStatus || (FlowRunExportJobStatus = {}));
export var FlowRunExportJobCancellationStatus;
(function (FlowRunExportJobCancellationStatus) {
    FlowRunExportJobCancellationStatus["Submitted"] = "Submitted";
})(FlowRunExportJobCancellationStatus || (FlowRunExportJobCancellationStatus = {}));
export const FLOW_RUN_EXPORT_JOB_LIST_DEFAULT_LIMIT = 20;
const FLOW_RUN_EXPORT_JOB_LIST_MAX_LIMIT = 100;
export const FlowRunExportJobCancelResponseSchema = z.strictObject({
    status: z.enum(FlowRunExportJobCancellationStatus),
});
/** Path parameters the endpoints addressing one export job accept. */
export const FlowRunExportJobIdParamsSchema = z.strictObject({
    jobId: z.uuid().describe('The export job.'),
});
/** Query parameters `GET /flow-runs/explore/export-jobs` accepts. */
export const FlowRunExportJobListQuerySchema = z.strictObject({
    flowId: z.uuid().describe('Return only export jobs of this flow.'),
    limit: z.coerce
        .number()
        .int()
        .positive()
        .max(FLOW_RUN_EXPORT_JOB_LIST_MAX_LIMIT)
        .describe('How many export jobs to return.')
        .optional(),
    offset: z.coerce
        .number()
        .int()
        .nonnegative()
        .describe('How many matches to skip, for paging.')
        .optional(),
});
export const FlowRunExportJobCreateResponseSchema = z.strictObject({
    jobId: z.uuid(),
    status: z.enum(FlowRunExportJobStatus),
});
const IsoDateTimeResponseSchema = z.iso.datetime();
/**
 * One export job as a caller sees it. The export itself is fetched through a download link rather
 * than from here, so a job carries only what the list needs to render.
 */
export const FlowRunExportJobSummarySchema = z.strictObject({
    id: z.uuid(),
    status: z.enum(FlowRunExportJobStatus),
    created: IsoDateTimeResponseSchema,
    rowCount: z.number().int().nullable(),
    error: z.string().nullable(),
    expiresAt: IsoDateTimeResponseSchema.nullable(),
});
export const FlowRunExportJobListPaginationSchema = z.strictObject({
    limit: z.number().int(),
    offset: z.number().int(),
});
export const FlowRunExportJobListResponseSchema = z.strictObject({
    exportJobs: z.array(FlowRunExportJobSummarySchema),
    pagination: FlowRunExportJobListPaginationSchema,
});
export const FlowRunExportJobDownloadResponseSchema = z.strictObject({
    downloadUrl: z.string(),
});
//# sourceMappingURL=exportJob.js.map